import { AdministrationHelper } from "@/Administration/Helpers/AdministrationHelper";
import { ImportClickableTextEnum } from "@/Administration/Models/UI/ClickableTexts/ImportClickableTextEnum";
import { LanguageOptions } from "@/Administration/Models/UI/Enums/Administration";
import { GroupEditMode } from "@/Administration/Models/UI/Group/GroupEditMode";
import { IGroupTabModel } from "@/Administration/Models/UI/Group/IGroupTabModel";
import { IServiceComboGridModel } from "@/Administration/Models/UI/ServiceCombo/IServiceComboGridModel";
import { AdministrationStore } from "@/Administration/Stores/AdministrationStore";
import { ClickableTextItem } from "@/Common/Api/ClickableText/Dto/ClickableTextItem";
import { EmployeeGroup } from "@/Common/Api/Employee/Dto/EmployeeGroup";
import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import { IComboOrServiceItem } from "@/Common/Models/Services/BaseServiceDefinitionModel";
import { ServiceOrComboTableItem } from "@/Common/Models/Services/ServiceOrComboTableItem";
import { EmployeeGroupUIModel } from "@/Common/Models/UI/Employee/EmployeeGroupUIModel";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BaseOperationHandler } from "@/Common/Stores/Handlers/Local/BaseOperationHandler";

class AdministrationGroupHandler extends BaseOperationHandler {
    constructor() {
        super();

        this.RegisterOperation(LocalOperations.AdministrationGroup.ToggleGroupSearchSideBar, this.toggleUserSearchSideBar);
        this.RegisterOperation(LocalOperations.AdministrationGroup.GetAllGroupSearch, this.getAllGroupSearch);
        this.RegisterOperation(LocalOperations.AdministrationGroup.OpenCreateNewGroupPopup, this.openCreateNewGroupPopup);
        this.RegisterOperation(LocalOperations.AdministrationGroup.CloseCreateNewGroupPopup, this.closeCreateNewGroupPopup);
        this.RegisterOperation(LocalOperations.AdministrationGroup.GetGroupInfo, this.getGroupInfo);
        this.RegisterOperation(LocalOperations.AdministrationGroup.IsEditGroupDetailsSetting, this.openGroupDetailsSetting);
        this.RegisterOperation(LocalOperations.AdministrationGroup.MutateGroupModel, this.mutateGroupModel);
        this.RegisterOperation(LocalOperations.AdministrationGroup.ChangeTagSelection, this.changeTagSelection);
        this.RegisterOperation(LocalOperations.AdministrationGroup.AddNewUsefulLink, this.addNewUsefulLink);
        this.RegisterOperation(LocalOperations.AdministrationGroup.OpenAddServiceCombo, this.openAddServiceCombo);
        this.RegisterOperation(LocalOperations.AdministrationGroup.AddUserServiceComboPopupClose, this.closeAddServiceCombo);
        this.RegisterOperation(LocalOperations.AdministrationGroup.SearchSettings_Open, this.openSearchSettings);
        this.RegisterOperation(LocalOperations.AdministrationGroup.SearchSettings_Close, this.closeSearchSettings);
        this.RegisterOperation(LocalOperations.AdministrationGroup.RefreshServices, this.refreshServices);
        this.RegisterOperation(LocalOperations.AdministrationGroup.SaveNewServicesCombo, this.addNewServicesComboToEditedGroup);
        this.RegisterOperation(LocalOperations.AdministrationGroup.CancelEditGroup, this.cancelEditGroup);
        this.RegisterOperation(LocalOperations.AdministrationGroup.SaveGroup, this.saveGroup);
        this.RegisterOperation(LocalOperations.AdministrationGroup.SaveAndApplyGroup, this.saveAndApplyGrop);
        this.RegisterOperation(LocalOperations.AdministrationGroup.OnChangeGroupName, this.onChangeGroupName);
        this.RegisterOperation(LocalOperations.AdministrationGroup.ModifyGroup, this.modifyGroup);
        this.RegisterOperation(LocalOperations.AdministrationGroup.SetTextSearch, this.setTextSearch);
        this.RegisterOperation(LocalOperations.AdministrationGroup.CloseRefreshClickableText, this.closeRefreshClickableText);
        this.RegisterOperation(LocalOperations.AdministrationGroup.DeleteClickableTextSection, this.deleteClickableTextSection);
        this.RegisterOperation(LocalOperations.AdministrationGroup.OpenImportClickableText, this.openImportClickabletext);
        this.RegisterOperation(LocalOperations.AdministrationGroup.GetAllClickableTectFromSpecificGroupForSpecificContext, this.getAllClickableTextFromSpecificGroupForSpecificContext);
        this.RegisterOperation(LocalOperations.AdministrationGroup.CloseClickableTextImport, this.closeClickableTextImport);
        this.RegisterOperation(LocalOperations.AdministrationGroup.SelectDetailsOfClickableText, this.selectDetailsOfClickableText);
        this.RegisterOperation(LocalOperations.AdministrationGroup.SetActivatedTabImportClickabeText, this.setActivatedTabImportClickabeText);
        this.RegisterOperation(LocalOperations.AdministrationGroup.CleanDetailsOfClickableText, this.cleanDetailsOfClickableText);
        this.RegisterOperation(LocalOperations.AdministrationGroup.SaveClickableTextImport, this.saveClickableTextImport);

        this.RegisterOperation(LocalOperations.AdministrationGroup.LoadClickableTextFromAnotherUser, this.getClickableTextFromAnotherUsers);
        this.RegisterOperation(LocalOperations.AdministrationGroup.IsRenameGroupPopupOpen, this.renameGroupPopup);
        this.RegisterOperation(LocalOperations.AdministrationGroup.RenameGroupName, this.renameGroupName);
        this.RegisterOperation(LocalOperations.AdministrationGroup.OnChangeLanguageForClickableText, this.changeLanguageForClickableText);
    }

    private toggleUserSearchSideBar(): void {
        let isMenuOpen = administrationStore.groupTabModel.get("SearchMenuOpen");
        administrationStore.groupTabModel = administrationStore.groupTabModel.set("SearchMenuOpen", !isMenuOpen);
    }

    private getAllGroupSearch(request: LocalEvent, store: AdministrationStore): void {
        store.groupAction.getAllSearchableGroups();
    }

    private openCreateNewGroupPopup(request: LocalEvent, store: AdministrationStore): void {
        store.groupTabModel = store.groupTabModel.set("IsCreateNewGroupPopupOpen", true);
        store.groupTabModel = store.groupTabModel.set("GroupName", "");
        sessionStore.showGlobalOverlay(true);
    }

    private closeCreateNewGroupPopup(request: LocalEvent, store: AdministrationStore): void {
        store.groupTabModel = store.groupTabModel.set("IsCreateNewGroupPopupOpen", false);
        store.groupTabModel = store.groupTabModel.set("GroupName", "");
        sessionStore.hideGlobalOverlay();
    }

    private getGroupInfo(request: LocalEvent, store: AdministrationStore): void {
        let groupId = request.Get<string>("GroupId");
        store.groupAction.GetGroupInfo(groupId);
        store.groupTabModel = store.groupTabModel.set("GroupEditMode", GroupEditMode.View);
        store.groupTabModel = store.groupTabModel.set("SelectedGroup", null);
        store.groupTabModel = this.ClearCurrentGroupSelection(store.groupTabModel);
    }

    private ClearCurrentGroupSelection(groupTabModel: IGroupTabModel): IGroupTabModel {
        groupTabModel = groupTabModel.set("SelectedGroup", null);
        groupTabModel = groupTabModel.set("EditedGroup", null);

        groupTabModel = groupTabModel.set("ClickableTextSpecificUser", null);
        groupTabModel = groupTabModel.set("NewUsefulLink", null);
        return groupTabModel;
    }

    private mutateGroupModel(request: LocalEvent, store: AdministrationStore): void {
        let group = request.Get<EmployeeGroupUIModel>("EditedGroup");
        store.groupTabModel = store.groupTabModel.set("EditedGroup", group);
    }

    private openGroupDetailsSetting(request: LocalEvent, store: AdministrationStore): void {
        let editedGroup = new EmployeeGroupUIModel();
        editedGroup.clone();
        let groupName = store.groupTabModel.get("GroupName");
        editedGroup.Model.Name = groupName;
        store.groupTabModel = store.groupTabModel.set("EditedGroup", editedGroup.clone());
        store.groupTabModel = store.groupTabModel.set("GroupEditMode", GroupEditMode.Create);
        store.groupTabModel = store.groupTabModel.set("IsCreateNewGroupPopupOpen", false);
        store.groupTabModel = store.groupTabModel.set("NewUsefulLink", null);
        store.groupTabModel = store.groupTabModel.set("SelectePDFTagIds", null);
        sessionStore.hideGlobalOverlay();
    }

    private addNewUsefulLink(request: LocalEvent, store: AdministrationStore): void {
        var newLink = request.Get<string>("NewLink");
        store.groupTabModel = store.groupTabModel.set("NewUsefulLink", newLink);
    }

    private changeTagSelection(request: LocalEvent, store: AdministrationStore): void {
        var selection = request.Get<number[]>("value");
        var cache = cacheStore.radPdfTagsCache;
        let group = store.groupTabModel.get("EditedGroup");

        let valuesToUpdate = cache
            .filter(item => selection.indexOf(item.Key) >= 0);

        let tagIds = valuesToUpdate.map(m => m.Key);
        let tagNames = valuesToUpdate.map(m => m.Value);
        store.groupTabModel = store.groupTabModel.set("PDFSearchKeywords", tagNames.toList());

        let mappedValuesToSend = valuesToUpdate.map(elem => elem.Value);
        store.groupTabModel = store.groupTabModel.set("SelectePDFTagIds", tagIds.toList());
        var mappedValued = mappedValuesToSend.toArray();
        var allowedFormTags: string = "";

        if (store.groupTabModel.get("GroupEditMode") == GroupEditMode.Create) {
            group.Model.AllowedTags = [];
            allowedFormTags = mappedValued.toString().replaceAll(",", "*");
            group.Model.AllowedTags.push(allowedFormTags);
            store.groupTabModel = store.groupTabModel.set("EditedGroup", group.clone());
        }
        else {
            group.Model.AllowedTags = [];
            allowedFormTags = mappedValued.toString().replaceAll(",", "*");
            group.Model.AllowedTags.push(allowedFormTags);
        }
    }

    private openAddServiceCombo(request: LocalEvent, store: AdministrationStore): void {
        store.groupTabModel = store.groupTabModel.set("IsOpenAddNewServiceCombo", true);
    }

    private closeAddServiceCombo(request: LocalEvent, store: AdministrationStore): void {
        store.groupTabModel = store.groupTabModel.set("IsOpenAddNewServiceCombo", false);

        // undo changes in edit model
        let editedGroup = store.groupTabModel.get("EditedGroup");
        let selectedGroup = store.groupTabModel.get("SelectedGroup");

        if (selectedGroup != null && editedGroup.Model.ServicesIDsOffered != null) {
            editedGroup.Model.ServicesIDsOffered = MyleHelper.CloneObject(selectedGroup.Model.ServicesIDsOffered);
        }
        else {
            editedGroup.Model.ServicesIDsOffered = [];
        }

        store.groupTabModel.set("EditedGroup", editedGroup);
        sessionStore.hideGlobalOverlay();
    }

    private openSearchSettings(request: LocalEvent, store: AdministrationStore): void {
        let model = store.groupTabModel.get("UserServiceComboGridModel");
        model = model.set("SearchSettingsOpen", !model.get("SearchSettingsOpen"));
        store.groupTabModel = store.groupTabModel.set("UserServiceComboGridModel", model);
    }

    private closeSearchSettings(request: LocalEvent, store: AdministrationStore): void {
        let model = store.groupTabModel.get("UserServiceComboGridModel");
        model = model.set("SearchSettingsOpen", false);
        store.groupTabModel = store.groupTabModel.set("UserServiceComboGridModel", model);
    }

    private refreshServices(request: LocalEvent, store: AdministrationStore): void {
        let closeSettings = request.Get<boolean>("closeSettings");
        let model = request.Get<IServiceComboGridModel>("model");
        let storeModel = store.groupTabModel.get("UserServiceComboGridModel");

        let filteredServices: ServiceOrComboTableItem<IComboOrServiceItem>[] = model == null ? storeModel.get("FilteredCombosAndServices").toArray() :
            AdministrationHelper.FilterAndOrderServiceComboDefinitions(
                cacheStore.ServiceDefinitionCache.toArray(),
                cacheStore.ServiceDefinitionComboCache.toArray(),
                model.get("EmployeesFiltered").toArray(),
                model.get("Sites").toArray(),
                model.get("Types").toArray(),
                model.get("Specializations").toArray(),
                storeModel.get("GridSortColumn"),
                storeModel.get("GridSortDirection"),
                model.get("Status_IsActiveChecked"),
                model.get("Status_IsInactiveChecked"),
                store.serviceComboGridModel.get("ServiceAndComboSearchText")
            );

        if (closeSettings) {
            storeModel = storeModel.set("SearchSettingsOpen", false);
        }
        if (model != null) {
            if (model.get("EmployeesFiltered").size == storeModel.get("EmployeesFiltered").size)
                storeModel = storeModel.set("EmployeesFiltered", model.get("EmployeesFiltered"));

            storeModel = storeModel.set("Sites", model.get("Sites"));
            storeModel = storeModel.set("Types", model.get("Types"));
            storeModel = storeModel.set("Specializations", model.get("Specializations"));
            storeModel = storeModel.set("Status_IsActiveChecked", model.get("Status_IsActiveChecked"));
            storeModel = storeModel.set("Status_IsInactiveChecked", model.get("Status_IsInactiveChecked"));
        }
        storeModel = storeModel.set("FilteredCombosAndServices", Immutable.List(filteredServices));
        store.groupTabModel = store.groupTabModel.set("UserServiceComboGridModel", storeModel);
    }

    private addNewServicesComboToEditedGroup(request: LocalEvent, store: AdministrationStore): void {
        let editedGroup = store.groupTabModel.get("EditedGroup");

        if (editedGroup.ServicesCombos == null)
            editedGroup.ServicesCombos = [];

        if (editedGroup.Model.ServicesIDsOffered == null)
            editedGroup.Model.ServicesIDsOffered = [];

        editedGroup.addNewServices();

        store.groupTabModel.set("EditedGroup", editedGroup);
        store.groupTabModel = store.groupTabModel.set("IsOpenAddNewServiceCombo", false);
    }

    private cancelEditGroup(request: LocalEvent, store: AdministrationStore): void {
        let groupModel = store.groupTabModel;
        if (groupModel.get("GroupEditMode") == GroupEditMode.Create)
            groupModel = groupModel.set("SelectedGroup", null);
        groupModel = groupModel.set("GroupEditMode", GroupEditMode.View);
        groupModel = groupModel.set("EditedGroup", null);
        groupModel = groupModel.set("NewUsefulLink", null);
        groupModel = groupModel.set("SelectePDFTagIds", null);

        store.groupTabModel = groupModel;
    }

    private saveGroup(request: LocalEvent, store: AdministrationStore): void {
        let groupModel = store.groupTabModel;
        let group = groupModel.get("EditedGroup");
        let newUsefulLink = groupModel.get("NewUsefulLink");

        if (newUsefulLink != null && newUsefulLink.length > 0) {
            group.addNewLink(newUsefulLink);
            groupModel = groupModel.set("EditedGroup", group);
        }

        if (IsNullOrWhiteSpace(group.Model.CreatedBy))
            group.Model.CreatedBy = sessionStore.userId;

        if (!IsNullOrWhiteSpace(group.Model.Name))
            store.groupAction.upsertGroup(group.Model);

        store.groupTabModel = groupModel;
    }

    private saveAndApplyGrop(request: LocalEvent, store: AdministrationStore): void {
        let group = store.groupTabModel.get("EditedGroup");
        let newUsefulLink = store.groupTabModel.get("NewUsefulLink");

        if (newUsefulLink != null && newUsefulLink.length > 0) {
            group.addNewLink(newUsefulLink);
            store.groupTabModel = store.groupTabModel.set("EditedGroup", group);
        }

        if (IsNullOrWhiteSpace(group.Model.CreatedBy))
            group.Model.CreatedBy = sessionStore.userId;

        if (!IsNullOrWhiteSpace(group.Model.Name))
            store.groupAction.upsertGroup(group.Model, true);
    }

    private onChangeGroupName(request: LocalEvent, store: AdministrationStore): void {
        let groupName = request.Get<string>("GroupName");
        store.groupTabModel = store.groupTabModel.set("GroupName", groupName);
    }

    private modifyGroup(request: LocalEvent, store: AdministrationStore): void {
        let editedGroup = store.groupTabModel.get("SelectedGroup").clone();
        store.groupTabModel = store.groupTabModel.set("EditedGroup", editedGroup);
        store.groupTabModel = store.groupTabModel.set("GroupEditMode", GroupEditMode.Edit);
    }

    private setTextSearch(request: LocalEvent, store: AdministrationStore): void {
        let text = request.Get<string>("TextSearch");
        store.groupTabModel = store.groupTabModel.set("SearchText", text);
    }

    private closeRefreshClickableText(request: LocalEvent, store: AdministrationStore): void {
        let editedGroup = store.groupTabModel.get("EditedGroup");
        let groupId = editedGroup.Model.Id;
        store.groupTabModel = store.groupTabModel.set("IsRefreshClickableText", true);
        window.setTimeout(() => store.groupAction.getAllCliackableText(groupId), 300);
    }

    private deleteClickableTextSection(request: LocalEvent, store: AdministrationStore): void {
        let groupId = request.Get<string>("GroupId");
        let context = request.Get<string>("Context");
        let editedGroup = store.groupTabModel.get("EditedGroup");

        let langClickableText = store.groupTabModel.get("LanguageOptionClickableText");
        let lang = sessionStore.getLanguageStringFromEnum(langClickableText);

        if (store.groupTabModel.get("GroupEditMode") == GroupEditMode.Edit)
            store.groupAction.deleteClickableTextSection(groupId, context, lang);
        else {
            if (editedGroup.Model.ClickableText && editedGroup.Model.ClickableText.length > 0) {
                editedGroup.Model.ClickableText = editedGroup.Model.ClickableText
                    .filter(x => !(
                        x.Context == context
                        && x.Language == lang
                    ));
            }
            else
                editedGroup.Model.ClickableText = [];

            store.groupTabModel = store.groupTabModel.set("EditedGroup", editedGroup.clone());
        }
    }

    private getAllClickableTextFromSpecificGroupForSpecificContext(request: LocalEvent, store: AdministrationStore): void {
        let context = store.groupTabModel.get("ContextForImportClickableText");
        let group = request.Get<EmployeeGroup>("SelectedItem");
        store.groupTabModel = store.groupTabModel.set("SpecificGroupForImportClickableText", group);
        store.groupTabModel = store.groupTabModel.set("AllListOfClickableTextDetailsForSpecificGroup", []);

        let langClickableText = store.groupTabModel.get("LanguageOptionClickableText");
        let lang = sessionStore.getLanguageStringFromEnum(langClickableText);

        store.groupAction.getTabDetailsFromSpecificGroup(context, group.Id, lang);
    }

    private openImportClickabletext(request: LocalEvent, store: AdministrationStore): void {
        let context = request.Get<string>("Context");
        let tab = request.Get<ImportClickableTextEnum>("Tab");
        let editedGroup = request.Get<EmployeeGroupUIModel>("EditedGroup");
        let langClickableText = store.groupTabModel.get("LanguageOptionClickableText");
        let lang = sessionStore.getLanguageStringFromEnum(langClickableText);

        store.groupTabModel = store.groupTabModel.set("SelectedTabImportClickableText", tab);
        store.groupTabModel = store.groupTabModel.set("ContextForImportClickableText", context);

        store.groupTabModel = store.groupTabModel.set("GroupClickableTextItems", editedGroup.Model.ClickableText.filter(x => x.Context == context && x.Language == lang));

        store.groupTabModel = store.groupTabModel.set("AllListOfClickableTextDetails", []);

        store.groupAction.getAllClickableTextCategories(context, lang);
    }

    private closeClickableTextImport(request: LocalEvent, store: AdministrationStore): void {
        store.groupTabModel = store.groupTabModel.set("IsImportClickableTextOpen", false);
        store.groupTabModel = store.groupTabModel.set("GroupClickableTextItems", []);
        store.groupTabModel = store.groupTabModel.set("AllListOfClickableTextDetailsForSpecificGroup", []);
        store.groupTabModel = store.groupTabModel.set("AllListOfClickableTextDetails", []);
    }

    private selectDetailsOfClickableText(request: LocalEvent, store: AdministrationStore): void {
        let tab = request.Get<any>("SelectedItem");
        let context = store.groupTabModel.get("ContextForImportClickableText");
        let langClickableText = store.groupTabModel.get("LanguageOptionClickableText");
        let lang = sessionStore.getLanguageStringFromEnum(langClickableText);
        store.groupAction.getClickableTextDetails(tab.toString(), context, lang);
    }

    private setActivatedTabImportClickabeText(request: LocalEvent, store: AdministrationStore): void {
        let tab = request.Get<ImportClickableTextEnum>("Tab");
        store.groupTabModel = store.groupTabModel.set("SelectedTabImportClickableText", tab);
        store.groupTabModel = store.groupTabModel.set("AllListOfClickableTextDetailsForSpecificGroup", []);
        store.groupTabModel = store.groupTabModel.set("AllListOfClickableTextDetails", []);
    }

    private cleanDetailsOfClickableText(request: LocalEvent, store: AdministrationStore): void {
        store.groupTabModel = store.groupTabModel.set("AllListOfClickableTextDetails", []);
        store.groupTabModel = store.groupTabModel.set("AllListOfClickableTextDetailsForSpecificGroup", []);
        let editedGroup = store.groupTabModel.get("EditedGroup");
        let context = store.groupTabModel.get("ContextForImportClickableText");

        let langClickableText = store.groupTabModel.get("LanguageOptionClickableText");
        let lang = sessionStore.getLanguageStringFromEnum(langClickableText);

        store.groupTabModel = store.groupTabModel.set("GroupClickableTextItems", editedGroup.Model.ClickableText.filter(x => x.Context == context && x.Language == lang));
    }

    private saveClickableTextImport(request: LocalEvent, store: AdministrationStore): void {
        let textListImporting = request.Get<ClickableTextItem[]>("TextList");
        let context = store.groupTabModel.get("ContextForImportClickableText");
        let langClickableText = store.groupTabModel.get("LanguageOptionClickableText");
        let lang = sessionStore.getLanguageStringFromEnum(langClickableText);

        store.groupTabModel = store.groupTabModel.set("SelectedTabImportClickableText", null);
        store.groupTabModel = store.groupTabModel.set("IsImportClickableTextOpen", false);
        store.groupTabModel = store.groupTabModel.set("AllTabNamesClickableTextForSpecificContext", []);
        store.groupTabModel = store.groupTabModel.set("ContextForImportClickableText", "");
        store.groupTabModel = store.groupTabModel.set("AllListOfClickableTextDetailsForSpecificGroup", []);
        if (textListImporting != null && textListImporting.length > 0) {
            let tabsName: string[] = [];
            tabsName = this.saveClickableTextForImporting(textListImporting);
            let editedGroup = store.groupTabModel.get("EditedGroup");

            if (store.groupTabModel.get("GroupEditMode") == GroupEditMode.Edit)
                store.groupAction.importListOfClickableText(textListImporting, editedGroup.Model.Id, context, tabsName, lang);
            else {
                if (editedGroup.Model.ClickableText && editedGroup.Model.ClickableText.length > 0) {
                    for (let text of textListImporting) {
                        editedGroup.Model.ClickableText = editedGroup.Model.ClickableText
                            .filter(x => !(
                                x.TabName == text.TabName
                                && x.Context == text.Context
                                && x.Language == text.Language
                            ));

                        editedGroup.Model.ClickableText.push(text);
                    }
                    editedGroup.Model.ClickableText.sortByProperty(x => x.TabOrderIndex);
                }
                else {
                    editedGroup.Model.ClickableText = [];
                    for (let text of textListImporting)
                        editedGroup.Model.ClickableText.push(text);
                }

                store.groupTabModel = store.groupTabModel.set("EditedGroup", editedGroup.clone());
            }
        }
    }

    private saveClickableTextForImporting(textList: ClickableTextItem[]): string[] {
        let tabsName: string[] = [];
        for (let text of textList)
            tabsName.push(text.TabName);

        return tabsName;
    }

    private getClickableTextFromAnotherUsers(request: LocalEvent, store: AdministrationStore): void {
        let employeeid = request.Get<string>("EmployeeId");
        store.groupAction.getCliackableTextSpecificUser(employeeid);
    }

    private renameGroupPopup(request: LocalEvent, store: AdministrationStore): void {
        let isPopupOpen = store.groupTabModel.get("IsRenameGroupPopupOpen");
        store.groupTabModel = store.groupTabModel.set("IsRenameGroupPopupOpen", !isPopupOpen);
        let selectedGroup = store.groupTabModel.get("SelectedGroup");
        if (!isPopupOpen) {
            store.groupTabModel = store.groupTabModel.set("GroupName", selectedGroup.Model.Name);
            sessionStore.showGlobalOverlay(true);
        }
        else {
            store.groupTabModel = store.groupTabModel.set("GroupName", "");
            sessionStore.hideGlobalOverlay();
        }
    }

    private renameGroupName(request: LocalEvent, store: AdministrationStore): void {
        let selectedGroup = store.groupTabModel.get("SelectedGroup");
        let groupName = store.groupTabModel.get("GroupName");
        store.groupTabModel = store.groupTabModel.set("IsRenameGroupPopupOpen", false);
        store.groupAction.updateGroupName(selectedGroup.Model.Id, groupName);
    }

    private changeLanguageForClickableText(request: LocalEvent, store: AdministrationStore): void {
        let lang = request.Get<LanguageOptions>("LanguageOption");
        store.groupTabModel = store.groupTabModel.set("LanguageOptionClickableText", lang);
    }
}

export { AdministrationGroupHandler };
